import React, { useState, Fragment } from "react"
import { useDispatch } from "react-redux"
import { LiaEdit } from "react-icons/lia"
import { toast } from "react-toastify"
import { FaTrashAlt } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { deleteAddress } from "services"
import { clearDeliveryAddress } from "@redux"
import { ConfirmationModal, IconButton } from "components"
import classes from "./CdsamAddressCard.module.scss"

const CdsamAddressCard = props => {
  const {
    userAddress,
    setModalContent,
    selectedUserAccount,
    setUserAddresses,
    selectedAddress,
    setSelectedAddress,
    setAddressForEdit
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const [sending, setSending] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const handleSelect = () => {
    setSelectedAddress(userAddress)
  }

  const handleSelectForEdit = (e) => {
    e.stopPropagation()

    setAddressForEdit(userAddress)

    setModalContent("form")
  }

  const handleDeleteAddress = async () => {
    setSending(true)

    try {
      await deleteAddress(
        userAddress._id, {
        accountId: selectedUserAccount._id
      })

      setShowConfirmationModal(false)

      selected &&
        dispatch(
          clearDeliveryAddress()
        )

      setSelectedAddress(null)

      setUserAddresses(prev =>
        prev.filter(address =>
          address._id !== userAddress._id
        )
      )
    } catch (err) {
      console.log(err)

      toast.error(t("آدرس_حذف_نشد"))

      setSending(false)
    }
  }

  const handleShowDeleteConfirmationModal = (e) => {
    e.stopPropagation()

    setShowConfirmationModal(true)
  }

  const selected =
    selectedAddress?._id === userAddress._id

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div
        onClick={handleSelect}
        className={clsx(
          classes["container"],
          selected && classes["active"]
        )}
      >
        <div
          className={clsx(
            classes["address"],
            isLtr && classes["address-ltr"]
          )}
        >
          {userAddress.address}
        </div>

        <div className={classes["icons"]}>
          <IconButton
            icon={LiaEdit}
            color="var(--color-success)"
            onClick={handleSelectForEdit}
            size={20}
            className={clsx(
              classes["icon"],
              isLtr && classes["icon-ltr"]
            )}
          />
          <IconButton
            icon={FaTrashAlt}
            color="var(--color-danger)"
            onClick={handleShowDeleteConfirmationModal}
            size={18}
            className={clsx(
              classes["icon"],
              isLtr && classes["icon-ltr"]
            )}
          />
        </div>
      </div>

      <ConfirmationModal
        title={t("آیا_می_خواهید_این_آدرس_را_حذف_کنین")}
        show={showConfirmationModal}
        onConfirm={handleDeleteAddress}
        onHide={() => setShowConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default CdsamAddressCard